module.exports = __webpack_public_path__ + "img/welcome-img@2x.6a1fb723.png";